export default function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="logo-mark" aria-label="CYCLOTRON">
      <circle cx="32" cy="32" r="28" />
      <circle cx="32" cy="32" r="18" strokeDasharray="2 3" />
      <line x1="32" y1="2" x2="32" y2="14" />
      <line x1="32" y1="50" x2="32" y2="62" />
      <line x1="2" y1="32" x2="14" y2="32" />
      <line x1="50" y1="32" x2="62" y2="32" />
      <path d="M32 32 m-8 0 a8 8 0 1 0 16 0 a8 8 0 1 0 -16 0 M32 32 m-4 0 a4 4 0 1 0 8 0 a4 4 0 1 0 -8 0" />
      <circle cx="32" cy="32" r="1.5" fill="currentColor" />
      <line x1="12" y1="12" x2="18" y2="18" />
      <line x1="46" y1="46" x2="52" y2="52" />
      <line x1="52" y1="12" x2="46" y2="18" />
      <line x1="12" y1="52" x2="18" y2="46" />
    </svg>
  );
}
